import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import SuccessToast from '../../toast/SuccessToast';
import UpdateCard from '../Modals/UpdateCard';
import { useLanguage } from '../../context/LanguageContext';
import { amountDisplay, dateDisplay } from '../../util/helper';

const SingleCard = ({ card, onCardAdd, deleteCard }) => {
    const [showModal, setShowModal] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [updateCard, setUpdateCard] = useState({});
    const { language, t } = useLanguage();

    const handleShow = (updateCard) => {
        setUpdateCard(updateCard);
        setShowModal(true);
    };

    const handleClose = () => {
        setShowModal(false);
    };

    const logoMap = {
        amex: '/assets/images/svg/amex.svg',
        visa: '/assets/images/svg/logo1.svg',
        master: '/assets/images/svg/master2.svg',
    };

    const location = useLocation();

    return (
        <>
            <div className="card-logo">
                <img
                    className="img-fluid"
                    src={logoMap[card.network_type] || logoMap.visa}
                    alt={`${card.network_type} logo`}
                />
                <div className="dropdown">
                    {location.pathname !== '/' && (
                        <Link to="#" className="back-btn" role="button" data-bs-toggle="dropdown">
                            <i className="icon" data-feather="more-horizontal"></i>
                        </Link>
                    )}

                    <ul className="dropdown-menu">
                        <li>
                            <Link className="dropdown-item" onClick={() => handleShow(card)} to="#">
                                {t('edit')}
                            </Link>
                        </li>
                        <li>
                            <Link
                                className="dropdown-item"
                                onClick={() => deleteCard(card)}
                                to="#delete"
                                data-bs-toggle="modal"
                            >
                                {t('remove')}
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="d-flex align-items-center justify-content-between">
                <div>
                    <h6 className="card-number">**** **** **** {card.card_number}</h6>
                    <h5 className="card-name">{card.card_holder_name.toUpperCase()}</h5>
                </div>
                <img
                    className="img-fluid chip"
                    src={'/assets/images/svg/card-chip.svg'}
                    alt="card-chip"
                />
            </div>
            <div className="d-flex justify-content-between">
                <h2 className="card-amount">{amountDisplay(card.account.balance, language)}</h2>
                <div className="card-numbers">
                    <h6 className="cvv-code">{t('expiryDate')}</h6>
                    <h6 className="text-white fw-semibold mt-1 margin-3">
                        {dateDisplay(card.expiry, language, 'monthYear')}
                    </h6>
                </div>
                <div className="card-numbers">
                    <h6 className="cvv-code">{t('cvv')}</h6>
                    <h6 className="text-white fw-semibold mt-1 margin-3">
                        {card.network_type === 'amex' ? 'XXXX' : 'XXX'}
                    </h6>
                </div>
            </div>

            {showModal && updateCard && (
                <UpdateCard
                    show={showModal}
                    onClose={handleClose}
                    updateCard={updateCard}
                    setShowToast={setShowToast}
                    onCardAdd={onCardAdd}
                />
            )}

            {showToast && (
                <SuccessToast
                    message={t('cardUpdateSuccessful')}
                    onClose={() => setShowToast(false)}
                />
            )}
        </>
    );
};

export default SingleCard;
